import { gql } from "@apollo/client";

export const FETCH_COMPANY = gql`
    query Company {
        company {
            id
            name
            createdAt
            updatedAt
            ownerId
            freePageQuota
            owner {
                id
                name
            }
            users {
                id
                name
                title
                pageQuota
                usedPages
                role
                size
            }
            details {
                description,
                employeeCount,
                metadata,
                generatedProfile,
                isGeneratingProfile
            }
        }
    }
`;